import { ActionTree } from 'vuex';
import { Campus, CampusWorkspace, City, LocationState } from './state';
import RootState from '@/store/root_state';
import { query, MicroserviceEnum } from '@/helpers/westeros';
import {
  allCampus,
  AllCampusQueryResult,
  allCities,
  AllCitiesQueryResult,
  campusInfo,
  CampusInfoQueryResult,
} from '@/store/graphql/queries/westerosQueries';
import { UpsertAdmissionMutationInput } from '@/store/graphql/mutations/westerosMutations';

const actions: ActionTree<LocationState, RootState> = {
  async UPDATE_CITY({ commit }, payload: { city: City }): Promise<void> {
    const { city } = payload;

    // TODO: save city on API

    commit('SET_CITY', city);
    commit('SET_AVAILABLE_CAMPUSES', []);
  },

  async UPDATE_CAMPUS({ dispatch }, payload: { campus: Campus }): Promise<void> {
    const { campus } = payload;

    const params: UpsertAdmissionMutationInput = { campusId: campus.id };

    await dispatch('UPSERT_ADMISSION', params);
  },

  async PULL_AVAILABLE_CITIES({ commit }): Promise<void> {
    const { data } = await query<AllCitiesQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allCities,
      { isAvailable: true },
      true,
    );

    const cities: City[] = data.allCities;

    commit(
      'SET_AVAILABLE_CITIES',
      cities.sort(({ city: city1 = '' }, { city: city2 = '' }) => city1.localeCompare(city2)),
    );
  },

  async PULL_AVAILABLE_CAMPUSES({ commit, state }): Promise<void> {
    const { city } = state;

    const { data } = await query<AllCampusQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allCampus,
      {
        city: city?.city,
        state: city?.state,
        isAvailable: true,
      },
      true,
    );

    const campuses: Campus[] = data.allCampus;

    commit(
      'SET_AVAILABLE_CAMPUSES',
      campuses.sort(({ name: name1 = '' }, { name: name2 = '' }) => name1.localeCompare(name2)),
    );
  },
  async PULL_CAMPUS_DETAILS({ commit }, payload: { campus: Campus }): Promise<void> {
    const { campus } = payload;

    const { data } = await query<CampusInfoQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      campusInfo,
      { id: campus.id },
      true,
    );

    const campusDetails: Campus = {
      name: data.campusInfo.name,
      address: data.campusInfo.address,
      description: data.campusInfo.description,
      neighborhood: data.campusInfo.neighborhood,
      photos: data.campusInfo.campusPhotos.map(({ photoUrl }) => photoUrl),
      ...data.campusInfo.campusAmenities.reduce(
        (partialCampus, { title = '', description = '', photoUrl = '', amenityType }) => {
          if (amenityType) partialCampus.amenities.push(amenityType);
          else partialCampus.workspaces.push({ title, description, image: photoUrl });

          return partialCampus;
        },
        { workspaces: [], amenities: [] } as { workspaces: CampusWorkspace[]; amenities: string[] },
      ),
    };

    commit('SET_CAMPUS_DETAILS', campusDetails);
  },
};

export default actions;
